'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BaseModel = require('../../utils/baseModel');

/**
* @class CommissionSaleTypeModel
*/
var CommissionSaleTypeModel = /*#__PURE__*/function (_BaseModel) {
  function CommissionSaleTypeModel() {
    _classCallCheck(this, CommissionSaleTypeModel);
    return _callSuper(this, CommissionSaleTypeModel, arguments);
  }
  _inherits(CommissionSaleTypeModel, _BaseModel);
  return _createClass(CommissionSaleTypeModel, [{
    key: "find",
    get:
    /**
    * @typedef { {} 
    * & Record<'name.ab:ilike', string> 
    * & Record<'name.ace:ilike', string> 
    * & Record<'name.ach:ilike', string> 
    * & Record<'name.ada:ilike', string> 
    * & Record<'name.ady:ilike', string> 
    * & Record<'name.aa:ilike', string> 
    * & Record<'name.afh:ilike', string> 
    * & Record<'name.af:ilike', string> 
    * & Record<'name.agq:ilike', string> 
    * & Record<'name.ain:ilike', string> 
    * & Record<'name.ak:ilike', string> 
    * & Record<'name.akk:ilike', string> 
    * & Record<'name.bss:ilike', string> 
    * & Record<'name.akz:ilike', string> 
    * & Record<'name.sq:ilike', string> 
    * & Record<'name.ale:ilike', string> 
    * & Record<'name.arq:ilike', string> 
    * & Record<'name.en_US:ilike', string> 
    * & Record<'name.ase:ilike', string> 
    * & Record<'name.am:ilike', string> 
    * & Record<'name.egy:ilike', string> 
    * & Record<'name.grc:ilike', string> 
    * & Record<'name.anp:ilike', string> 
    * & Record<'name.njo:ilike', string> 
    * & Record<'name.ar:ilike', string> 
    * & Record<'name.an:ilike', string> 
    * & Record<'name.arc:ilike', string> 
    * & Record<'name.aro:ilike', string> 
    * & Record<'name.arp:ilike', string> 
    * & Record<'name.arw:ilike', string> 
    * & Record<'name.hy:ilike', string> 
    * & Record<'name.rup:ilike', string> 
    * & Record<'name.frp:ilike', string> 
    * & Record<'name.as:ilike', string> 
    * & Record<'name.ast:ilike', string> 
    * & Record<'name.asa:ilike', string> 
    * & Record<'name.cch:ilike', string> 
    * & Record<'name.en_AU:ilike', string> 
    * & Record<'name.de_AT:ilike', string> 
    * & Record<'name.av:ilike', string> 
    * & Record<'name.ae:ilike', string> 
    * & Record<'name.awa:ilike', string> 
    * & Record<'name.ay:ilike', string> 
    * & Record<'name.az:ilike', string> 
    * & Record<'name.bfq:ilike', string> 
    * & Record<'name.ksf:ilike', string> 
    * & Record<'name.bfd:ilike', string> 
    * & Record<'name.bqi:ilike', string> 
    * & Record<'name.ban:ilike', string> 
    * & Record<'name.bal:ilike', string> 
    * & Record<'name.bm:ilike', string> 
    * & Record<'name.bax:ilike', string> 
    * & Record<'name.bjn:ilike', string> 
    * & Record<'name.bas:ilike', string> 
    * & Record<'name.ba:ilike', string> 
    * & Record<'name.eu:ilike', string> 
    * & Record<'name.bbc:ilike', string> 
    * & Record<'name.bar:ilike', string> 
    * & Record<'name.bej:ilike', string> 
    * & Record<'name.be:ilike', string> 
    * & Record<'name.bem:ilike', string> 
    * & Record<'name.bez:ilike', string> 
    * & Record<'name.bn:ilike', string> 
    * & Record<'name.bew:ilike', string> 
    * & Record<'name.bho:ilike', string> 
    * & Record<'name.bik:ilike', string> 
    * & Record<'name.bin:ilike', string> 
    * & Record<'name.bpy:ilike', string> 
    * & Record<'name.bi:ilike', string> 
    * & Record<'name.byn:ilike', string> 
    * & Record<'name.zbl:ilike', string> 
    * & Record<'name.brx:ilike', string> 
    * & Record<'name.bs:ilike', string> 
    * & Record<'name.brh:ilike', string> 
    * & Record<'name.bra:ilike', string> 
    * & Record<'name.pt_BR:ilike', string> 
    * & Record<'name.br:ilike', string> 
    * & Record<'name.en_GB:ilike', string> 
    * & Record<'name.bug:ilike', string> 
    * & Record<'name.bg:ilike', string> 
    * & Record<'name.bum:ilike', string> 
    * & Record<'name.bua:ilike', string> 
    * & Record<'name.my:ilike', string> 
    * & Record<'name.cad:ilike', string> 
    * & Record<'name.frc:ilike', string> 
    * & Record<'name.en_CA:ilike', string> 
    * & Record<'name.fr_CA:ilike', string> 
    * & Record<'name.yue:ilike', string> 
    * & Record<'name.cps:ilike', string> 
    * & Record<'name.car:ilike', string> 
    * & Record<'name.ca:ilike', string> 
    * & Record<'name.cay:ilike', string> 
    * & Record<'name.ceb:ilike', string> 
    * & Record<'name.tzm:ilike', string> 
    * & Record<'name.dtp:ilike', string> 
    * & Record<'name.ckb:ilike', string> 
    * & Record<'name.esu:ilike', string> 
    * & Record<'name.shu:ilike', string> 
    * & Record<'name.chg:ilike', string> 
    * & Record<'name.ch:ilike', string> 
    * & Record<'name.ce:ilike', string> 
    * & Record<'name.chr:ilike', string> 
    * & Record<'name.chy:ilike', string> 
    * & Record<'name.chb:ilike', string> 
    * & Record<'name.cgg:ilike', string> 
    * & Record<'name.qug:ilike', string> 
    * & Record<'name.zh:ilike', string> 
    * & Record<'name.chn:ilike', string> 
    * & Record<'name.chp:ilike', string> 
    * & Record<'name.cho:ilike', string> 
    * & Record<'name.cu:ilike', string> 
    * & Record<'name.chk:ilike', string> 
    * & Record<'name.cv:ilike', string> 
    * & Record<'name.nwc:ilike', string> 
    * & Record<'name.syc:ilike', string> 
    * & Record<'name.ksh:ilike', string> 
    * & Record<'name.swb:ilike', string> 
    * & Record<'name.swc:ilike', string> 
    * & Record<'name.cop:ilike', string> 
    * & Record<'name.kw:ilike', string> 
    * & Record<'name.co:ilike', string> 
    * & Record<'name.cr:ilike', string> 
    * & Record<'name.mus:ilike', string> 
    * & Record<'name.crh:ilike', string> 
    * & Record<'name.hr:ilike', string> 
    * & Record<'name.cs:ilike', string> 
    * & Record<'name.dak:ilike', string> 
    * & Record<'name.da:ilike', string> 
    * & Record<'name.dar:ilike', string> 
    * & Record<'name.dzg:ilike', string> 
    * & Record<'name.del:ilike', string> 
    * & Record<'name.din:ilike', string> 
    * & Record<'name.dv:ilike', string> 
    * & Record<'name.doi:ilike', string> 
    * & Record<'name.dgr:ilike', string> 
    * & Record<'name.dua:ilike', string> 
    * & Record<'name.nl:ilike', string> 
    * & Record<'name.dyu:ilike', string> 
    * & Record<'name.dz:ilike', string> 
    * & Record<'name.frs:ilike', string> 
    * & Record<'name.efi:ilike', string> 
    * & Record<'name.arz:ilike', string> 
    * & Record<'name.eka:ilike', string> 
    * & Record<'name.elx:ilike', string> 
    * & Record<'name.ebu:ilike', string> 
    * & Record<'name.egl:ilike', string> 
    * & Record<'name.en:ilike', string> 
    * & Record<'name.myv:ilike', string> 
    * & Record<'name.eo:ilike', string> 
    * & Record<'name.et:ilike', string> 
    * & Record<'name.pt_PT:ilike', string> 
    * & Record<'name.es_ES:ilike', string> 
    * & Record<'name.ee:ilike', string> 
    * & Record<'name.ewo:ilike', string> 
    * & Record<'name.ext:ilike', string> 
    * & Record<'name.fan:ilike', string> 
    * & Record<'name.fat:ilike', string> 
    * & Record<'name.fo:ilike', string> 
    * & Record<'name.hif:ilike', string> 
    * & Record<'name.fj:ilike', string> 
    * & Record<'name.fil:ilike', string> 
    * & Record<'name.fi:ilike', string> 
    * & Record<'name.nl_BE:ilike', string> 
    * & Record<'name.fon:ilike', string> 
    * & Record<'name.gur:ilike', string> 
    * & Record<'name.fr:ilike', string> 
    * & Record<'name.fur:ilike', string> 
    * & Record<'name.ff:ilike', string> 
    * & Record<'name.gaa:ilike', string> 
    * & Record<'name.gag:ilike', string> 
    * & Record<'name.gl:ilike', string> 
    * & Record<'name.gan:ilike', string> 
    * & Record<'name.lg:ilike', string> 
    * & Record<'name.gay:ilike', string> 
    * & Record<'name.gba:ilike', string> 
    * & Record<'name.gez:ilike', string> 
    * & Record<'name.ka:ilike', string> 
    * & Record<'name.de:ilike', string> 
    * & Record<'name.aln:ilike', string> 
    * & Record<'name.bbj:ilike', string> 
    * & Record<'name.glk:ilike', string> 
    * & Record<'name.gil:ilike', string> 
    * & Record<'name.gom:ilike', string> 
    * & Record<'name.gon:ilike', string> 
    * & Record<'name.gor:ilike', string> 
    * & Record<'name.got:ilike', string> 
    * & Record<'name.grb:ilike', string> 
    * & Record<'name.el:ilike', string> 
    * & Record<'name.gn:ilike', string> 
    * & Record<'name.gu:ilike', string> 
    * & Record<'name.guz:ilike', string> 
    * & Record<'name.gwi:ilike', string> 
    * & Record<'name.hai:ilike', string> 
    * & Record<'name.ht:ilike', string> 
    * & Record<'name.hak:ilike', string> 
    * & Record<'name.ha:ilike', string> 
    * & Record<'name.haw:ilike', string> 
    * & Record<'name.he:ilike', string> 
    * & Record<'name.hz:ilike', string> 
    * & Record<'name.hil:ilike', string> 
    * & Record<'name.hi:ilike', string> 
    * & Record<'name.ho:ilike', string> 
    * & Record<'name.hit:ilike', string> 
    * & Record<'name.hmn:ilike', string> 
    * & Record<'name.hu:ilike', string> 
    * & Record<'name.hup:ilike', string> 
    * & Record<'name.iba:ilike', string> 
    * & Record<'name.ibb:ilike', string> 
    * & Record<'name.is:ilike', string> 
    * & Record<'name.io:ilike', string> 
    * & Record<'name.ig:ilike', string> 
    * & Record<'name.ilo:ilike', string> 
    * & Record<'name.smn:ilike', string> 
    * & Record<'name.id:ilike', string> 
    * & Record<'name.izh:ilike', string> 
    * & Record<'name.inh:ilike', string> 
    * & Record<'name.ia:ilike', string> 
    * & Record<'name.ie:ilike', string> 
    * & Record<'name.iu:ilike', string> 
    * & Record<'name.ik:ilike', string> 
    * & Record<'name.ga:ilike', string> 
    * & Record<'name.it:ilike', string> 
    * & Record<'name.jam:ilike', string> 
    * & Record<'name.ja:ilike', string> 
    * & Record<'name.jv:ilike', string> 
    * & Record<'name.kaj:ilike', string> 
    * & Record<'name.dyo:ilike', string> 
    * & Record<'name.jrb:ilike', string> 
    * & Record<'name.jpr:ilike', string> 
    * & Record<'name.jut:ilike', string> 
    * & Record<'name.kbd:ilike', string> 
    * & Record<'name.kea:ilike', string> 
    * & Record<'name.kab:ilike', string> 
    * & Record<'name.kac:ilike', string> 
    * & Record<'name.kgp:ilike', string> 
    * & Record<'name.kkj:ilike', string> 
    * & Record<'name.kl:ilike', string> 
    * & Record<'name.kln:ilike', string> 
    * & Record<'name.xal:ilike', string> 
    * & Record<'name.kam:ilike', string> 
    * & Record<'name.kbl:ilike', string> 
    * & Record<'name.kn:ilike', string> 
    * & Record<'name.kr:ilike', string> 
    * & Record<'name.kaa:ilike', string> 
    * & Record<'name.krc:ilike', string> 
    * & Record<'name.krl:ilike', string> 
    * & Record<'name.ks:ilike', string> 
    * & Record<'name.csb:ilike', string> 
    * & Record<'name.kaw:ilike', string> 
    * & Record<'name.kk:ilike', string> 
    * & Record<'name.ken:ilike', string> 
    * & Record<'name.kha:ilike', string> 
    * & Record<'name.km:ilike', string> 
    * & Record<'name.kho:ilike', string> 
    * & Record<'name.khw:ilike', string> 
    * & Record<'name.ki:ilike', string> 
    * & Record<'name.kmb:ilike', string> 
    * & Record<'name.krj:ilike', string> 
    * & Record<'name.rw:ilike', string> 
    * & Record<'name.kiu:ilike', string> 
    * & Record<'name.tlh:ilike', string> 
    * & Record<'name.bkm:ilike', string> 
    * & Record<'name.kv:ilike', string> 
    * & Record<'name.koi:ilike', string> 
    * & Record<'name.kg:ilike', string> 
    * & Record<'name.kok:ilike', string> 
    * & Record<'name.ko:ilike', string> 
    * & Record<'name.kfo:ilike', string> 
    * & Record<'name.kos:ilike', string> 
    * & Record<'name.avk:ilike', string> 
    * & Record<'name.khq:ilike', string> 
    * & Record<'name.ses:ilike', string> 
    * & Record<'name.kpe:ilike', string> 
    * & Record<'name.kri:ilike', string> 
    * & Record<'name.kj:ilike', string> 
    * & Record<'name.kum:ilike', string> 
    * & Record<'name.ku:ilike', string> 
    * & Record<'name.kru:ilike', string> 
    * & Record<'name.kut:ilike', string> 
    * & Record<'name.nmg:ilike', string> 
    * & Record<'name.ky:ilike', string> 
    * & Record<'name.quc:ilike', string> 
    * & Record<'name.lad:ilike', string> 
    * & Record<'name.lah:ilike', string> 
    * & Record<'name.lkt:ilike', string> 
    * & Record<'name.lam:ilike', string> 
    * & Record<'name.lag:ilike', string> 
    * & Record<'name.lo:ilike', string> 
    * & Record<'name.ltg:ilike', string> 
    * & Record<'name.la:ilike', string> 
    * & Record<'name.es_419:ilike', string> 
    * & Record<'name.lv:ilike', string> 
    * & Record<'name.lzz:ilike', string> 
    * & Record<'name.lez:ilike', string> 
    * & Record<'name.lij:ilike', string> 
    * & Record<'name.li:ilike', string> 
    * & Record<'name.ln:ilike', string> 
    * & Record<'name.lfn:ilike', string> 
    * & Record<'name.lzh:ilike', string> 
    * & Record<'name.lt:ilike', string> 
    * & Record<'name.liv:ilike', string> 
    * & Record<'name.jbo:ilike', string> 
    * & Record<'name.lmo:ilike', string> 
    * & Record<'name.nds:ilike', string> 
    * & Record<'name.sli:ilike', string> 
    * & Record<'name.dsb:ilike', string> 
    * & Record<'name.loz:ilike', string> 
    * & Record<'name.lu:ilike', string> 
    * & Record<'name.lua:ilike', string> 
    * & Record<'name.lui:ilike', string> 
    * & Record<'name.smj:ilike', string> 
    * & Record<'name.lun:ilike', string> 
    * & Record<'name.luo:ilike', string> 
    * & Record<'name.lb:ilike', string> 
    * & Record<'name.luy:ilike', string> 
    * & Record<'name.mde:ilike', string> 
    * & Record<'name.mk:ilike', string> 
    * & Record<'name.jmc:ilike', string> 
    * & Record<'name.mad:ilike', string> 
    * & Record<'name.maf:ilike', string> 
    * & Record<'name.mag:ilike', string> 
    * & Record<'name.vmf:ilike', string> 
    * & Record<'name.mai:ilike', string> 
    * & Record<'name.mak:ilike', string> 
    * & Record<'name.mgh:ilike', string> 
    * & Record<'name.kde:ilike', string> 
    * & Record<'name.mg:ilike', string> 
    * & Record<'name.ms:ilike', string> 
    * & Record<'name.ml:ilike', string> 
    * & Record<'name.mt:ilike', string> 
    * & Record<'name.mnc:ilike', string> 
    * & Record<'name.mdr:ilike', string> 
    * & Record<'name.man:ilike', string> 
    * & Record<'name.mni:ilike', string> 
    * & Record<'name.gv:ilike', string> 
    * & Record<'name.mi:ilike', string> 
    * & Record<'name.arn:ilike', string> 
    * & Record<'name.mr:ilike', string> 
    * & Record<'name.chm:ilike', string> 
    * & Record<'name.mh:ilike', string> 
    * & Record<'name.mwr:ilike', string> 
    * & Record<'name.mas:ilike', string> 
    * & Record<'name.mzn:ilike', string> 
    * & Record<'name.byv:ilike', string> 
    * & Record<'name.men:ilike', string> 
    * & Record<'name.mwv:ilike', string> 
    * & Record<'name.mer:ilike', string> 
    * & Record<'name.mgo:ilike', string> 
    * & Record<'name.es_MX:ilike', string> 
    * & Record<'name.mic:ilike', string> 
    * & Record<'name.dum:ilike', string> 
    * & Record<'name.enm:ilike', string> 
    * & Record<'name.frm:ilike', string> 
    * & Record<'name.gmh:ilike', string> 
    * & Record<'name.mga:ilike', string> 
    * & Record<'name.nan:ilike', string> 
    * & Record<'name.min:ilike', string> 
    * & Record<'name.xmf:ilike', string> 
    * & Record<'name.mwl:ilike', string> 
    * & Record<'name.lus:ilike', string> 
    * & Record<'name.ar_001:ilike', string> 
    * & Record<'name.moh:ilike', string> 
    * & Record<'name.mdf:ilike', string> 
    * & Record<'name.ro_MD:ilike', string> 
    * & Record<'name.lol:ilike', string> 
    * & Record<'name.mn:ilike', string> 
    * & Record<'name.mfe:ilike', string> 
    * & Record<'name.ary:ilike', string> 
    * & Record<'name.mos:ilike', string> 
    * & Record<'name.mul:ilike', string> 
    * & Record<'name.mua:ilike', string> 
    * & Record<'name.ttt:ilike', string> 
    * & Record<'name.mye:ilike', string> 
    * & Record<'name.naq:ilike', string> 
    * & Record<'name.na:ilike', string> 
    * & Record<'name.nv:ilike', string> 
    * & Record<'name.ng:ilike', string> 
    * & Record<'name.nap:ilike', string> 
    * & Record<'name.ne:ilike', string> 
    * & Record<'name.new:ilike', string> 
    * & Record<'name.sba:ilike', string> 
    * & Record<'name.nnh:ilike', string> 
    * & Record<'name.jgo:ilike', string> 
    * & Record<'name.yrl:ilike', string> 
    * & Record<'name.nia:ilike', string> 
    * & Record<'name.niu:ilike', string> 
    * & Record<'name.zxx:ilike', string> 
    * & Record<'name.nog:ilike', string> 
    * & Record<'name.nd:ilike', string> 
    * & Record<'name.frr:ilike', string> 
    * & Record<'name.se:ilike', string> 
    * & Record<'name.nso:ilike', string> 
    * & Record<'name.no:ilike', string> 
    * & Record<'name.nb:ilike', string> 
    * & Record<'name.nn:ilike', string> 
    * & Record<'name.nov:ilike', string> 
    * & Record<'name.nus:ilike', string> 
    * & Record<'name.nym:ilike', string> 
    * & Record<'name.ny:ilike', string> 
    * & Record<'name.nyn:ilike', string> 
    * & Record<'name.tog:ilike', string> 
    * & Record<'name.nyo:ilike', string> 
    * & Record<'name.nzi:ilike', string> 
    * & Record<'name.nqo:ilike', string> 
    * & Record<'name.oc:ilike', string> 
    * & Record<'name.oj:ilike', string> 
    * & Record<'name.ang:ilike', string> 
    * & Record<'name.fro:ilike', string> 
    * & Record<'name.goh:ilike', string> 
    * & Record<'name.sga:ilike', string> 
    * & Record<'name.non:ilike', string> 
    * & Record<'name.peo:ilike', string> 
    * & Record<'name.pro:ilike', string> 
    * & Record<'name.or:ilike', string> 
    * & Record<'name.om:ilike', string> 
    * & Record<'name.osa:ilike', string> 
    * & Record<'name.os:ilike', string> 
    * & Record<'name.ota:ilike', string> 
    * & Record<'name.pal:ilike', string> 
    * & Record<'name.pfl:ilike', string> 
    * & Record<'name.pau:ilike', string> 
    * & Record<'name.pi:ilike', string> 
    * & Record<'name.pam:ilike', string> 
    * & Record<'name.pag:ilike', string> 
    * & Record<'name.pap:ilike', string> 
    * & Record<'name.ps:ilike', string> 
    * & Record<'name.pdc:ilike', string> 
    * & Record<'name.fa:ilike', string> 
    * & Record<'name.phn:ilike', string> 
    * & Record<'name.pcd:ilike', string> 
    * & Record<'name.pms:ilike', string> 
    * & Record<'name.pdt:ilike', string> 
    * & Record<'name.pon:ilike', string> 
    * & Record<'name.pl:ilike', string> 
    * & Record<'name.pnt:ilike', string> 
    * & Record<'name.pt:ilike', string> 
    * & Record<'name.prg:ilike', string> 
    * & Record<'name.pa:ilike', string> 
    * & Record<'name.qu:ilike', string> 
    * & Record<'name.raj:ilike', string> 
    * & Record<'name.rap:ilike', string> 
    * & Record<'name.rar:ilike', string> 
    * & Record<'name.rif:ilike', string> 
    * & Record<'name.rgn:ilike', string> 
    * & Record<'name.ro:ilike', string> 
    * & Record<'name.rm:ilike', string> 
    * & Record<'name.rom:ilike', string> 
    * & Record<'name.rof:ilike', string> 
    * & Record<'name.root:ilike', string> 
    * & Record<'name.rtm:ilike', string> 
    * & Record<'name.rug:ilike', string> 
    * & Record<'name.rn:ilike', string> 
    * & Record<'name.ru:ilike', string> 
    * & Record<'name.rue:ilike', string> 
    * & Record<'name.rwk:ilike', string> 
    * & Record<'name.ssy:ilike', string> 
    * & Record<'name.sah:ilike', string> 
    * & Record<'name.sam:ilike', string> 
    * & Record<'name.saq:ilike', string> 
    * & Record<'name.sm:ilike', string> 
    * & Record<'name.sgs:ilike', string> 
    * & Record<'name.sad:ilike', string> 
    * & Record<'name.sg:ilike', string> 
    * & Record<'name.sbp:ilike', string> 
    * & Record<'name.sa:ilike', string> 
    * & Record<'name.sat:ilike', string> 
    * & Record<'name.sc:ilike', string> 
    * & Record<'name.sas:ilike', string> 
    * & Record<'name.sdc:ilike', string> 
    * & Record<'name.stq:ilike', string> 
    * & Record<'name.saz:ilike', string> 
    * & Record<'name.sco:ilike', string> 
    * & Record<'name.gd:ilike', string> 
    * & Record<'name.sly:ilike', string> 
    * & Record<'name.sel:ilike', string> 
    * & Record<'name.seh:ilike', string> 
    * & Record<'name.see:ilike', string> 
    * & Record<'name.sr:ilike', string> 
    * & Record<'name.sh:ilike', string> 
    * & Record<'name.srr:ilike', string> 
    * & Record<'name.sei:ilike', string> 
    * & Record<'name.ksb:ilike', string> 
    * & Record<'name.shn:ilike', string> 
    * & Record<'name.sn:ilike', string> 
    * & Record<'name.ii:ilike', string> 
    * & Record<'name.scn:ilike', string> 
    * & Record<'name.sid:ilike', string> 
    * & Record<'name.bla:ilike', string> 
    * & Record<'name.szl:ilike', string> 
    * & Record<'name.zh_Hans:ilike', string> 
    * & Record<'name.sd:ilike', string> 
    * & Record<'name.si:ilike', string> 
    * & Record<'name.sms:ilike', string> 
    * & Record<'name.den:ilike', string> 
    * & Record<'name.sk:ilike', string> 
    * & Record<'name.sl:ilike', string> 
    * & Record<'name.xog:ilike', string> 
    * & Record<'name.sog:ilike', string> 
    * & Record<'name.so:ilike', string> 
    * & Record<'name.snk:ilike', string> 
    * & Record<'name.azb:ilike', string> 
    * & Record<'name.nr:ilike', string> 
    * & Record<'name.alt:ilike', string> 
    * & Record<'name.sma:ilike', string> 
    * & Record<'name.st:ilike', string> 
    * & Record<'name.es:ilike', string> 
    * & Record<'name.srn:ilike', string> 
    * & Record<'name.zgh:ilike', string> 
    * & Record<'name.suk:ilike', string> 
    * & Record<'name.sux:ilike', string> 
    * & Record<'name.su:ilike', string> 
    * & Record<'name.sus:ilike', string> 
    * & Record<'name.sw:ilike', string> 
    * & Record<'name.ss:ilike', string> 
    * & Record<'name.sv:ilike', string> 
    * & Record<'name.fr_CH:ilike', string> 
    * & Record<'name.gsw:ilike', string> 
    * & Record<'name.de_CH:ilike', string> 
    * & Record<'name.syr:ilike', string> 
    * & Record<'name.shi:ilike', string> 
    * & Record<'name.tl:ilike', string> 
    * & Record<'name.ty:ilike', string> 
    * & Record<'name.dav:ilike', string> 
    * & Record<'name.tg:ilike', string> 
    * & Record<'name.tly:ilike', string> 
    * & Record<'name.tmh:ilike', string> 
    * & Record<'name.ta:ilike', string> 
    * & Record<'name.trv:ilike', string> 
    * & Record<'name.twq:ilike', string> 
    * & Record<'name.tt:ilike', string> 
    * & Record<'name.te:ilike', string> 
    * & Record<'name.ter:ilike', string> 
    * & Record<'name.teo:ilike', string> 
    * & Record<'name.tet:ilike', string> 
    * & Record<'name.th:ilike', string> 
    * & Record<'name.bo:ilike', string> 
    * & Record<'name.tig:ilike', string> 
    * & Record<'name.ti:ilike', string> 
    * & Record<'name.tem:ilike', string> 
    * & Record<'name.tiv:ilike', string> 
    * & Record<'name.tli:ilike', string> 
    * & Record<'name.tpi:ilike', string> 
    * & Record<'name.tkl:ilike', string> 
    * & Record<'name.to:ilike', string> 
    * & Record<'name.fit:ilike', string> 
    * & Record<'name.zh_Hant:ilike', string> 
    * & Record<'name.tkr:ilike', string> 
    * & Record<'name.tsd:ilike', string> 
    * & Record<'name.tsi:ilike', string> 
    * & Record<'name.ts:ilike', string> 
    * & Record<'name.tn:ilike', string> 
    * & Record<'name.tcy:ilike', string> 
    * & Record<'name.tum:ilike', string> 
    * & Record<'name.aeb:ilike', string> 
    * & Record<'name.tr:ilike', string> 
    * & Record<'name.tk:ilike', string> 
    * & Record<'name.tru:ilike', string> 
    * & Record<'name.tvl:ilike', string> 
    * & Record<'name.tyv:ilike', string> 
    * & Record<'name.tw:ilike', string> 
    * & Record<'name.kcg:ilike', string> 
    * & Record<'name.udm:ilike', string> 
    * & Record<'name.uga:ilike', string> 
    * & Record<'name.uk:ilike', string> 
    * & Record<'name.umb:ilike', string> 
    * & Record<'name.und:ilike', string> 
    * & Record<'name.hsb:ilike', string> 
    * & Record<'name.ur:ilike', string> 
    * & Record<'name.ug:ilike', string> 
    * & Record<'name.uz:ilike', string> 
    * & Record<'name.vai:ilike', string> 
    * & Record<'name.ve:ilike', string> 
    * & Record<'name.vec:ilike', string> 
    * & Record<'name.vep:ilike', string> 
    * & Record<'name.vi:ilike', string> 
    * & Record<'name.vo:ilike', string> 
    * & Record<'name.vro:ilike', string> 
    * & Record<'name.vot:ilike', string> 
    * & Record<'name.vun:ilike', string> 
    * & Record<'name.wa:ilike', string> 
    * & Record<'name.wae:ilike', string> 
    * & Record<'name.war:ilike', string> 
    * & Record<'name.wbp:ilike', string> 
    * & Record<'name.was:ilike', string> 
    * & Record<'name.guc:ilike', string> 
    * & Record<'name.cy:ilike', string> 
    * & Record<'name.vls:ilike', string> 
    * & Record<'name.fy:ilike', string> 
    * & Record<'name.mrj:ilike', string> 
    * & Record<'name.wal:ilike', string> 
    * & Record<'name.wo:ilike', string> 
    * & Record<'name.wuu:ilike', string> 
    * & Record<'name.xh:ilike', string> 
    * & Record<'name.hsn:ilike', string> 
    * & Record<'name.yav:ilike', string> 
    * & Record<'name.yao:ilike', string> 
    * & Record<'name.yap:ilike', string> 
    * & Record<'name.ybb:ilike', string> 
    * & Record<'name.yi:ilike', string> 
    * & Record<'name.yo:ilike', string> 
    * & Record<'name.zap:ilike', string> 
    * & Record<'name.dje:ilike', string> 
    * & Record<'name.zza:ilike', string> 
    * & Record<'name.zea:ilike', string> 
    * & Record<'name.zen:ilike', string> 
    * & Record<'name.za:ilike', string> 
    * & Record<'name.gbz:ilike', string> 
    * & Record<'name.zu:ilike', string> 
    * & Record<'name.zun:ilike', string> 
    * & Record<'shown:eq', boolean> 
    * & Record<'order:eq', number> 
    * & Record<'order:gt', number> 
    * & Record<'order:lt', number> 
    * & Record<'order:lte', number> 
    * & Record<'order:gte', number> 
    * & Record<'taskTemplateId:eq', string> 
    * & Record<'taskTemplateId:like', string> 
    * & Record<'taskTemplateId:ilike', string> 
    * & Record<'taskTemplateId:in', string> 
    * & Record<'type:eq', string> 
    * & Record<'type:like', string> 
    * & Record<'type:ilike', string> 
    * & Record<'type:in', string> 
    * & Record<'deleted:eq', boolean> 
    * & Record<'page', number> 
    * & Record<'perPage', number> 
    * & Record<'orderBy', string> 
    * & Record<'orderByDesc', string> 
    * } CommissionSaletypeFindSDKRequestSearchParams
    */

    /**
    * @typedef {SDKRequestOptions} CommissionSaletypeFindSDKRequestOptions
    * @augments SDKRequestOptions
    *
    * @property { CommissionSaletypeFindSDKRequestSearchParams } [searchParams] - Query string that will be added to the request URL. This will override the query string in url.
    */

    /**
    * @return { CommissionSaletypeFindSDKRequest }
    */
    function get() {
      var _this = this;
      var _path = 'tenant/{tenantId}/commission/saleTypes';

      /**
      * find (GET /tenant/{tenantId}/commission/saleTypes)
      * Get saleTypes
      *
      *
      * @typedef {function} CommissionSaletypeFindSDKRequest
      * 
      * @param {string}            tenantId   
      * @param { CommissionSaletypeFindSDKRequestOptions } options
      * @returns {Promise<{ results : Array<*>, pagination : { page : number, pages : number, perPage : number, total : number } }>|*}
      */
      var request = function request(tenantId) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _path = _path.replace('{tenantId}', tenantId);
        return _this._http.get(_path, options);
      };

      /**
      * find (GET /tenant/{tenantId}/commission/saleTypes)
      * Get saleTypes
      *
      *
      * @function
      * @memberof CommissionSaletypeFindSDKRequest#
      * 
      * @param {string}            tenantId   
      * @param  { CommissionSaletypeFindSDKRequestOptions }  options
      * @returns {Promise<any[]>|*}
      */
      request.paginate = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tenantId) {
          var options,
            full,
            _yield$_this$_http$ge,
            pagination,
            results,
            i,
            _yield$_this$_http$ge2,
            moreResults,
            _args = arguments;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _path = _path.replace('{tenantId}', tenantId);
                if (!options.searchParams) {
                  options.searchParams = {
                    page: 1
                  };
                }
                full = [];
                _context.next = 6;
                return _this._http.get(_path, options).json();
              case 6:
                _yield$_this$_http$ge = _context.sent;
                pagination = _yield$_this$_http$ge.pagination;
                results = _yield$_this$_http$ge.results;
                full.push.apply(full, _toConsumableArray(results));
                if (!(pagination.pages > 1)) {
                  _context.next = 22;
                  break;
                }
                i = pagination.page + 1;
              case 12:
                if (!(i <= pagination.pages)) {
                  _context.next = 22;
                  break;
                }
                options.searchParams.page = i;
                _context.next = 16;
                return _this._http.get(_path, options).json();
              case 16:
                _yield$_this$_http$ge2 = _context.sent;
                moreResults = _yield$_this$_http$ge2.results;
                full.push.apply(full, _toConsumableArray(moreResults));
              case 19:
                ++i;
                _context.next = 12;
                break;
              case 22:
                return _context.abrupt("return", full);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      return request;
    }

    /**
    * get (GET /tenant/{tenantId}/commission/saleType/{id})
    * Get sale type by id
    *
    *
    * 
    * @param {string}            tenantId   
    * @param {string}            id   
    * @param {SDKRequestOptions} options
    * @returns {Promise<*>|*}
    */
  }, {
    key: "get",
    value: function get(tenantId, id) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _path = 'tenant/{tenantId}/commission/saleType/{id}';
      _path = _path.replace('{tenantId}', tenantId);
      _path = _path.replace('{id}', id);
      return this._http.get(_path, options);
    }

    /**
    * update (PATCH /tenant/{tenantId}/commission/saleType/{id})
    * Update sale type
    *
    * roles : 
    *    - service  
    *    - super_admin  
    *    - admin_commission   
    *
    * 
    * @param {string}            tenantId   
    * @param {string}            id   
    * @param {Object}            json
    * @param {SDKRequestOptions} options
    * @returns {Promise<*>|*}
    */
  }, {
    key: "update",
    value: function update(tenantId, id) {
      var json = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _path = 'tenant/{tenantId}/commission/saleType/{id}';
      _path = _path.replace('{tenantId}', tenantId);
      _path = _path.replace('{id}', id);
      return this._http.patch(_path, _objectSpread({
        json: json
      }, options));
    }

    /**
    * create (POST /tenant/{tenantId}/commission/saleType)
    * Create a new sale type
    *
    * roles : 
    *    - service  
    *    - super_admin  
    *    - admin_commission   
    *
    * 
    * @param {string}            tenantId   
    * @param {Object}            json
    * @param {SDKRequestOptions} options
    * @returns {Promise<*>|*}
    */
  }, {
    key: "create",
    value: function create(tenantId) {
      var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _path = 'tenant/{tenantId}/commission/saleType';
      _path = _path.replace('{tenantId}', tenantId);
      return this._http.post(_path, _objectSpread({
        json: json
      }, options));
    }
  }]);
}(BaseModel);
module.exports = CommissionSaleTypeModel;